import { LobbyTrendingEventsQueryVariables } from '@/api/events/query.generated';
import { useGetLobbyContentQuery } from '@/api/lobby/query.generated';
import { UseQueryArgs } from 'urql';

import { useLobbyQueryVariables } from './use-lobby-query-variables';

/**
 * React hook that wraps `useGetLobbyContentQuery` and automatically injects
 * the set of variables produced by `useLobbyQueryVariables`
 *
 * ! `urql` determines a query’s cache key from the GraphQL document and the variables that are supplied with it.
 *
 * @param options – `urql` `UseQueryArgs` except `variables` (those are fixed internally).
 */
export const useFantasyLobbyQueryWithVariables = (
    options: Omit<UseQueryArgs<LobbyTrendingEventsQueryVariables>, 'query' | 'variables'> = {
        requestPolicy: 'cache-first',
    }
) => {
    const lobbyQueryVariables = useLobbyQueryVariables();

    return useGetLobbyContentQuery({
        ...options,
        variables: lobbyQueryVariables,
    });
};
